// extracted by mini-css-extract-plugin
module.exports = {"products":"EB","productContainer":"FB","overFlowVisible":"GB","resultsHeading":"HB","oosMessaging":"IB","bestExp":"JB","bestExpRecognized":"KB","bestExpMobile":"LB"};